import { Navigate } from "react-router-dom";
import AuthService from "./Authorization.service";

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const token = AuthService.getAccessToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
